// src/hooks/useCamera.ts
import { useState, useRef } from 'react'

export function useCamera() {
  const [photo, setPhoto] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const inputRef = useRef<HTMLInputElement>(null)

  const capturePhoto = () => {
    inputRef.current?.click()
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    setError(null)

    if (file.size > 20 * 1024 * 1024) {
      setError('Bilden är för stor (max 20MB)')
      return
    }

    const reader = new FileReader()
    reader.onload = () => {
      setPhoto(reader.result as string)
    }
    reader.onerror = () => {
      setError('Kunde inte läsa bilden')
    }
    reader.readAsDataURL(file)

    // Reset input so same file can be selected again
    e.target.value = ''
  }

  const clearPhoto = () => {
    setPhoto(null)
    setError(null)
  }

  return { photo, error, capturePhoto, handleFileChange, clearPhoto, inputRef }
}
